import ResumeItem from '@/features/privateCompanies/pages/Totals/components/ResumeItem';
import { SupportTicketTotalizerData } from '../types/supportTicketTotalizer.type';
import { supportTicketsResumeItems } from '../constants/supportTicketTotalizer.constant';

interface SupportTicketsResumeListProps {
  data: SupportTicketTotalizerData;
  kind?: 'external' | 'internal'
}

const SupportTicketsResumeList = ({ data, kind = 'external' }: SupportTicketsResumeListProps) => {
  return (
    <div className="flex gap-6">
      {supportTicketsResumeItems({data, kind}).map((itemConfig, index) => <ResumeItem isCurrencyValue={false} key={index} {...itemConfig}/>)}
    </div>
  )
}

export default SupportTicketsResumeList